var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            "show-close": true,
            title: _vm.$t("changepwd.interceptionAlert"),
            visible: _vm.tipDialog,
            top: "10vh",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "problemInterceptPromptMap" },
            _vm._l(_vm.problemInterceptPromptMap, function (key, value) {
              return _c(
                "div",
                { key: value },
                [
                  _c("div", { staticClass: "packageReturn" }, [
                    _vm._v(_vm._s(value)),
                  ]),
                  _vm._l(key, function (itemKey, indexKey) {
                    return _c(
                      "div",
                      { key: indexKey, staticClass: "packageReturnItem" },
                      [_vm._v(" " + _vm._s(itemKey) + " ")]
                    )
                  }),
                ],
                2
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }